// excelExportService.js
import * as XLSX from "xlsx";


const getTimestamp = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};
/**
 * Exports Live URLs to Excel
 * @param {Object} apiResponse - API response object containing liveurls and liveurl
 */
export const exportLiveUrlsToExcel = (apiResponse) => {
  const liveUrls = [
  ...(apiResponse.liveurl ? [apiResponse.liveurl] : []),
  ...(apiResponse.liveurls?.length ? apiResponse.liveurls : []),
  ...(apiResponse.curriculum_liveurl ? [apiResponse.curriculum_liveurl] : []),
  ...(apiResponse.liveurlsCurriculum?.length ? apiResponse.liveurlsCurriculum : []),
  ...(apiResponse.mediaProtectionLiveurl ? [apiResponse.mediaProtectionLiveurl] : []),
  ...(apiResponse.mediaProtectionLiveurls?.length ? apiResponse.mediaProtectionLiveurls : [])
];


if (apiResponse.liveurls.length === 0) {
  return;
}

  // Prepare Excel Rows – SL No + URL
  const excelData = liveUrls.map((url, index) => ({
    "SL NO": index + 1,
    "All Live URLs": url,
  }));

  // Sheet Heading
  const sheetHeading = [
  ["All live URLs from the levels below the current pushed live path."],
  [],
  [`Pushed live path : ${apiResponse.pushedLocation}`],
  [],
];


  // Convert JSON to sheet
  const worksheet = XLSX.utils.json_to_sheet(excelData, { origin: "A5" });

  // Add heading on top
  XLSX.utils.sheet_add_aoa(worksheet, sheetHeading, { origin: "A1" });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Live URLs");

  const fileName = `LiveURLs_${getTimestamp()}.xlsx`;

  XLSX.writeFile(workbook, fileName);
};
